import { UserService } from './user.service';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RoleService } from './role.service';
import { WindowService } from './window.service';
import { VersionCheckService } from './version-check.service';
import { SettingsService } from './settings.service';

const SERVICES = [
	RoleService,
	UserService,
	WindowService,
	VersionCheckService,
	SettingsService
];

@NgModule({
	imports: [
		CommonModule,
	],
	providers: [
		...SERVICES,
	]
})
export class DataModule {
	static forRoot(): ModuleWithProviders<DataModule> {
		return {
			ngModule: DataModule,
			providers: [
				...SERVICES,
			],
		};
	}
}
